var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerTableleftarr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0897 10L20.0371 10.8315L15.1318 15.1304L20.0304 19.4352L19.0829 20.2667L13.714 15.5491C13.4535 15.3191 13.4535 14.9476 13.714 14.7176L19.0897 10Z",
    fill: "#current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5711 10L15.5186 10.8315L10.6133 15.1304L15.5118 19.4352L14.5644 20.2667L9.19545 15.5491C8.9349 15.3191 8.9349 14.9476 9.19545 14.7176L14.5711 10Z",
    fill: "#current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTableleftarr);
export default __webpack_public_path__ + "static/media/CustomerTableleftarr.3563f263cbebc2394be8aa34de230868.svg";
export { ForwardRef as ReactComponent };